var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFileUpload = function SvgFileUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.454 1.58-8 8.5 1.092 1.028 6.704-7.123v15.11h1.5V3.984l6.704 7.123 1.092-1.028-8-8.5L12 1l-.546.58ZM21 20.844H3v1.5h18v-1.5Z"
  })));
};
export { SvgFileUpload as ReactComponent };
export default __webpack_public_path__ + "61615d1c65127483302d4f06b8e5c98d.svg";